import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivWorkshopRateViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
export class WorkshopContractRateBase implements MrfiktivWorkshopRateViewModelGen {
  /**
   * The hourly billing rate for painting work
   */

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.paintHourlyBillingRate"
  })
  paintHourlyBillingRate?: number | null;

  get hourlyBillingRatePaintFormable(): number | null | undefined {
    if (this.paintHourlyBillingRate === null || this.paintHourlyBillingRate === undefined) {
      return null;
    }

    return this.paintHourlyBillingRate;
  }
  set hourlyBillingRatePaintFormable(v: number | null | undefined) {
    if (v === null || v === undefined) {
      this.paintHourlyBillingRate = v;
    } else if (`${v}` === "") {
      this.paintHourlyBillingRate = null;
    } else {
      this.paintHourlyBillingRate = Number(v);
    }
  }

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.mechanicalHourlyBillingRate"
  })
  mechanicalHourlyBillingRate?: number | null;

  get hourlyBillingRateMechanicalFormable(): number | null | undefined {
    if (this.mechanicalHourlyBillingRate === null || this.mechanicalHourlyBillingRate === undefined) {
      return null;
    }

    return this.mechanicalHourlyBillingRate;
  }
  set hourlyBillingRateMechanicalFormable(v: number | null | undefined) {
    if (v === null || v === undefined) {
      this.mechanicalHourlyBillingRate = v;
    } else if (`${v}` === "") {
      this.mechanicalHourlyBillingRate = null;
    } else {
      this.mechanicalHourlyBillingRate = Number(v);
    }
  }

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.paintMaterialPercentage"
  })
  paintMaterialPercentage?: number | null;

  get paintMaterialPercentageFormable(): number | null | undefined {
    if (this.paintMaterialPercentage === null || this.paintMaterialPercentage === undefined) {
      return null;
    }

    return this.paintMaterialPercentage;
  }
  set paintMaterialPercentageFormable(v: number | null | undefined) {
    if (v === null || v === undefined) {
      this.paintMaterialPercentage = v;
    } else if (`${v}` === "") {
      this.paintMaterialPercentage = null;
    } else {
      this.paintMaterialPercentage = Number(v);
    }
  }

  /**
   * The spare parts discount in percentage
   */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.sparePartsDiscountPercentage"
  })
  sparePartsDiscountPercentage?: number | null;

  get sparePartsDiscountFormable(): number | null | undefined {
    if (this.sparePartsDiscountPercentage === null || this.sparePartsDiscountPercentage === undefined) {
      return null;
    }

    return this.sparePartsDiscountPercentage;
  }
  set sparePartsDiscountFormable(v: number | null | undefined) {
    if (v === null || v === undefined) {
      this.sparePartsDiscountPercentage = v;
    } else if (`${v}` === "") {
      this.sparePartsDiscountPercentage = null;
    } else {
      this.sparePartsDiscountPercentage = Number(v);
    }
  }

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.sparePartsSurchargePercentage"
  })
  sparePartsSurchargePercentage?: number | null;

  get sparePartsSurchargeFormable(): number | null | undefined {
    return this.sparePartsSurchargePercentage;
  }
  set sparePartsSurchargeFormable(v: number | null | undefined) {
    if (v === null || v === undefined) {
      this.sparePartsSurchargePercentage = v;
    } else if (`${v}` === "") {
      this.sparePartsSurchargePercentage = null;
    } else {
      this.sparePartsSurchargePercentage = Number(v);
    }
  }

  constructor(data?: Partial<MrfiktivWorkshopRateViewModelGen>) {
    this.paintHourlyBillingRate = data?.paintHourlyBillingRate;
    this.mechanicalHourlyBillingRate = data?.mechanicalHourlyBillingRate;
    this.paintMaterialPercentage = data?.paintMaterialPercentage;
    this.sparePartsDiscountPercentage = data?.sparePartsDiscountPercentage;
    this.sparePartsSurchargePercentage = data?.sparePartsSurchargePercentage;
  }

  map(data: MrfiktivWorkshopRateViewModelGen): void {
    this.paintHourlyBillingRate = data?.paintHourlyBillingRate;
    this.mechanicalHourlyBillingRate = data?.mechanicalHourlyBillingRate;
    this.paintMaterialPercentage = data?.paintMaterialPercentage;
    this.sparePartsDiscountPercentage = data?.sparePartsDiscountPercentage;
    this.sparePartsSurchargePercentage = data?.sparePartsSurchargePercentage;
  }
}

type IWorkshopContractRate = WorkshopContractRateBase;
const WorkshopContractRate = Filter.createForClass(WorkshopContractRateBase);

export { IWorkshopContractRate, WorkshopContractRate };
